// extracted by mini-css-extract-plugin
module.exports = {"root":"PartnerSection_root__YcOId","content":"PartnerSection_content__b70ow","text":"PartnerSection_text__qvMxH"};